export enum FILE_TYPE {
  PNG = 'PNG',
  JPEG = 'JPEG',
  JPG = 'JPG',
  PDF = 'PDF',
}
export const FILE_MAX_SIZE_ERROR = 'Max Size is 5MB';

export default FILE_TYPE;
